import classNames from "classnames";
import { AssetCard } from "features/Application/components/Card/Assets/AssetCard/AssetCard";
import { RStatus } from "features/Application/types";
import { Carousel } from "features/Home/components/Carousel/Carousel";
import { req, reset } from "features/Home/redux/homePageContent/homeRecentCoursesSlice";
import { selectRecentCoursesState } from "features/Home/redux/homePageContent/selectors";
import { Routes } from "features/common/routes";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { type ContentItem } from "features/AssetResults/types";
import styles from "./RecentCourses.module.scss";
import { getRouteForEntity } from "features/AssetResults/components/ContentList/NavigatableContentItem";
import { CardSessionStatus } from "features/Application/components/Card/CardSessionStatus/CardSessionStatus";
import { isUndefined } from "lodash";

const cx = classNames.bind(styles);

const emptyItems = Array(5).fill({} as ContentItem);

export const RecentCourses: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["application"]);
  const recentCoursesState = useSelector(selectRecentCoursesState);
  const items: ContentItem[] = recentCoursesState.status === RStatus.Got ? recentCoursesState.items : emptyItems;

  useEffect(() => {
    dispatch(req());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  if (
    recentCoursesState.status === RStatus.Error ||
    (recentCoursesState.status === RStatus.Got && recentCoursesState.items.length === 0)
  ) {
    return null;
  }

  return (
    <div className={cx(styles.root)}>
      <Carousel
        items={items}
        title={t("carousel.recentActivity")}
        renderCard={item => {
          const baseItemDetailsPath = getRouteForEntity(item.entityType);
          return (
            <AssetCard
              loading={recentCoursesState.status === RStatus.Pending}
              item={item}
              to={`${baseItemDetailsPath}/${item.id}`}
              metaClassName="keepMetaInline"
              extraMeta={
                !isUndefined(item.completionStatus) && (
                  <CardSessionStatus entityType={item.entityType} status={item.completionStatus} />
                )
              }
            />
          );
        }}
      />
      <div className={cx(styles.viewAll)}>
        <Link to={Routes.Discover.myHistory}>{t("common.viewAll")}</Link>
      </div>
    </div>
  );
};
